import React, { useState, useEffect, useContext } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Trans } from 'gatsby-plugin-react-i18next';
import { getSrc } from 'gatsby-plugin-image';
import find from 'lodash/find';
import isEqual from 'lodash/isEqual';
import { useI18next } from 'gatsby-plugin-react-i18next';
import LazyLoader from '../../components/LazyLoader';
import { window } from 'browser-monads';
import axios from 'axios';

// Materia-ui v5
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';

import { ImageWebp } from '../ProductPage';
import ReactImageZoom from 'react-image-zoom';

import trustMoneyBack from '../../images/gray-moneyback.png';
import trustReturns from '../../images/Grey-Returns.png';
import trustWarranty from '../../images/Grey-Warranty.png';
import trustCheckout from '../../images/Grey-Checkout.png';

import ShopifyContext from '../../context/ShopifyContext';
import { ActiveWrapper, ProductColorValue, Thumbnail } from './styles';
import { ShopifyProduct } from '../ProductPage';
import NumberInput from '../../components/NumberInput';
import { trackMautic } from '../../hooks/mauticTracker';

// show strap items with Slide
import Slider from 'react-slick';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import './react-slick.css';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

import { DISCOUNT_AMOUNT, PRICE_THRESHOLD } from '../../constants/pricing';

interface Props {
  product: ShopifyProduct;
  images: ImageWebp[];
  thumbnails: ImageWebp[];
}

const ProductHeaderContent: React.FC<Props> = ({ product, images, thumbnails }) => {
  const { language } = useI18next();
  const [activeImage, setActiveImage] = useState(0);
  if (images.length === 0) return null;

  const {
    options,
    variants,
    variants: [initialVariant],
    priceRangeV2: { minVariantPrice, maxVariantPrice },
  } = product;
  const [variant, setVariant] = useState({ ...initialVariant });
  const [quantity, setQuantity] = useState(1);
  const { client, addVariantToCart } = useContext(ShopifyContext);
  const [open, setOpen] = React.useState(false); /*open add to cart message*/
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [activeWindowWidth, setActiveWindowWidth] = useState(parseInt((window.innerWidth - 410) / 100) * 100);

  // copy from gatsby-shopify-starter, update variant availability online dynamically.
  const [variantAvailable, setVariantAvailable] = useState(variant.availableForSale);
  const [variantPrice, setVariantPrice] = useState(variant.price);
  const [fetchedProduct, setFetchedProduct] = useState(null);

  useEffect(() => {
    const fetchProduct = async (productId) => {
      const fetched = await client.product.fetch(productId);
      setFetchedProduct(fetched);
    };

    fetchProduct(product.shopifyId);
  }, []);

  useEffect(() => {
    if (fetchedProduct) {
      const result = fetchedProduct.variants.filter((item) => item.id === variant.shopifyId);
      setVariantAvailable(result[0]?.available ?? fetchedProduct.variants[0].available);
      setVariantPrice(result[0]?.price.amount ?? fetchedProduct.variants[0].price.amount);
    }
  }, [fetchedProduct, variant]);

  const [salesData, setSalesData] = useState(null);

  // extra leather strap
  const leatherStraps = [
    {
      name: 'PS-L003J',
      shopifyId: 'gid://shopify/ProductVariant/43580900835563',
      title: 'Yellow Brown',
      availableForSale: true,
      price: '14.49',
      checked: false,
      image:
        'https://cdn.shopify.com/s/files/1/0654/0361/7515/products/pagani-design-watch-strap-003J-color-yellow-brown_130x130_crop_center.jpg?v=1669180115',
    },
    {
      name: 'PS-L003J',
      shopifyId: 'gid://shopify/ProductVariant/43580900868331',
      title: 'Wine Red',
      availableForSale: true,
      price: '14.49',
      checked: false,
      image:
        'https://cdn.shopify.com/s/files/1/0654/0361/7515/products/pagani-design-watch-strap-003J-color-wine-red_130x130_crop_center.jpg?v=1669180115',
    },
    {
      name: 'PS-L003J',
      shopifyId: 'gid://shopify/ProductVariant/43580958474475',
      title: 'Deep Blue',
      availableForSale: true,
      price: '14.49',
      checked: false,
      image:
        'https://cdn.shopify.com/s/files/1/0654/0361/7515/products/pagani-design-watch-strap-003J-color-deep-blue_130x130_crop_center.jpg?v=1669180115',
    },
    {
      name: 'PS-L003J',
      shopifyId: 'gid://shopify/ProductVariant/43580958507243',
      title: 'Gray Black',
      availableForSale: true,
      price: '14.49',
      checked: false,
      image:
        'https://cdn.shopify.com/s/files/1/0654/0361/7515/products/pagani-design-watch-strap-003J-color-gray-black_130x130_crop_center.jpg?v=1669180115',
    },
    {
      name: 'PS-L052B',
      shopifyId: 'gid://shopify/ProductVariant/43581134766315',
      title: 'Yellow Brown',
      availableForSale: true,
      price: '14.49',
      checked: false,
      image:
        'https://cdn.shopify.com/s/files/1/0654/0361/7515/products/pagani-design-watch-strap-052B-color-yellow-brown_130x130_crop_center.jpg?v=1669185523',
    },
    {
      name: 'PS-L052B',
      shopifyId: 'gid://shopify/ProductVariant/43581134799083',
      title: 'Royal Red',
      availableForSale: true,
      price: '14.49',
      checked: false,
      image:
        'https://cdn.shopify.com/s/files/1/0654/0361/7515/products/pagani-design-watch-strap-052B-color-royal-red_130x130_crop_center.jpg?v=1669185523',
    },
    {
      name: 'PS-L052B',
      shopifyId: 'gid://shopify/ProductVariant/43581134831851',
      title: 'Royal Blue',
      availableForSale: true,
      price: '14.49',
      checked: false,
      image:
        'https://cdn.shopify.com/s/files/1/0654/0361/7515/products/pagani-design-watch-strap-052B-color-royal-blue_130x130_crop_center.jpg?v=1669185523',
    },
    {
      name: 'PS-L052B',
      shopifyId: 'gid://shopify/ProductVariant/43581134864619',
      title: 'Gray Black',
      availableForSale: true,
      price: '14.49',
      checked: false,
      image:
        'https://cdn.shopify.com/s/files/1/0654/0361/7515/products/pagani-design-watch-strap-052B-color-gray-black_130x130_crop_center.jpg?v=1669185512',
    },

    {
      name: 'PS-L003NT',
      shopifyId: 'gid://shopify/ProductVariant/43581258989803',
      title: 'Yellow Brown',
      availableForSale: true,
      price: '14.49',
      checked: false,
      image:
        'https://cdn.shopify.com/s/files/1/0654/0361/7515/products/pagani-design-watch-strap-003NT-color-yellow-brown_130x130_crop_center.jpg?v=1669187585',
    },
    {
      name: 'PS-L003NT',
      shopifyId: 'gid://shopify/ProductVariant/43581259022571',
      title: 'Wine Red',
      availableForSale: true,
      price: '14.49',
      checked: false,
      image:
        'https://cdn.shopify.com/s/files/1/0654/0361/7515/products/pagani-design-watch-strap-003NT-color-wine-red_130x130_crop_center.jpg?v=1669187585',
    },
    {
      name: 'PS-L003NT',
      shopifyId: 'gid://shopify/ProductVariant/43581259055339',
      title: 'Deep Blue',
      availableForSale: true,
      price: '14.49',
      checked: false,
      image:
        'https://cdn.shopify.com/s/files/1/0654/0361/7515/products/pagani-design-watch-strap-003NT-color-royal-blue_130x130_crop_center.jpg?v=1669187585',
    },
    {
      name: 'PS-L003NT',
      shopifyId: 'gid://shopify/ProductVariant/43581259088107',
      title: 'Gray Black',
      availableForSale: true,
      price: '14.49',
      checked: false,
      image:
        'https://cdn.shopify.com/s/files/1/0654/0361/7515/products/pagani-design-watch-strap-003NT-color-gray-black_130x130_crop_center.jpg?v=1669187585',
    },
  ];

  const [extraStrap, setExtraStrap] = useState([false, false, false, false, false, false, false, false, false, false, false, false, false]);

  const SlickArrowLeft = (props) => {
    return (
      <NavigateBeforeIcon
        fontSize="large"
        sx={{
          borderRadius: '2px',
          width: { xs: '1.2rem', lg: '1.5rem' },
          height: { xs: '1.2rem', lg: '1.5rem' },
          zIndex: '100',
        }}
        {...props}
      />
    );
  };

  const SlickArrowRight = (props) => {
    return (
      <NavigateNextIcon
        fontSize="large"
        sx={{
          borderRadius: '2px',
          width: { xs: '1.2rem', lg: '1.5rem' },
          height: { xs: '1.2rem', lg: '1.5rem' },
          zIndex: '100',
        }}
        {...props}
      />
    );
  };

  const ExtraStrapSlickProps = {
    dots: true,
    infinite: true,
    lazyLoad: false,
    adaptiveHeight: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    slide: 'a',
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    responsive: [
      {
        breakpoint: 1180,
        settings: {
          // dots: false,
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 1079,
        settings: {
          // dots: false,
          slidesToShow: 4,
          slidesToScroll: 4,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 767,
        settings: {
          // dots: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 450,
        settings: {
          // dots: false,
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 319,
        settings: {
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
    ],
  };

  const ThumbnailSlickProps = {
    dots: true,
    infinite: true,
    lazyLoad: false,
    adaptiveHeight: true,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 2,
    initialSlide: 0,
    slide: 'a',
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    responsive: [
      {
        breakpoint: 530,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 100,
        settings: {
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
    ],
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setWindowWidth(window.innerWidth);
      setActiveWindowWidth(parseInt((window.innerWidth - 410) / 100) * 100);
    }
  }, []);
  useEffect(() => {
    window.addEventListener('resize', (e) => {
      setWindowWidth(window.innerWidth);
      setActiveWindowWidth(parseInt((window.innerWidth - 410) / 100) * 100);
      // console.log("widow=", windowWidth, "active=", activeWindowWidth);
    });
    // return () => window.removeEventListener("resize", handleResize);
  }, [window.innerWidth]);

  useEffect(() => {
    // 获取当前日期，并返回 yyyy-mm-dd 格式的字符串
    const getFormattedDate = () => {
      let currentDate = new Date();
      let month = String(currentDate.getMonth() + 1).padStart(2, '0');
      let day = String(currentDate.getDate()).padStart(2, '0');
      let year = currentDate.getFullYear();
      let currentFormattedDate = year + '-' + month + '-' + day;

      return currentFormattedDate;
    };

    // 检查 localStorage 中是否有数据，如果有，检查数据是否是当天的
    const checkLocalStorageForData = () => {
      if (typeof window === 'undefined') {
        return null;
      }
      let currentFormattedDate = getFormattedDate();
      let storedData = window.localStorage.getItem('salesData');
      if (storedData) {
        // 将数据从 JSON 字符串还原为对象
        // storedData = JSON.parse(storedData);
        try {
          // 尝试将数据从 JSON 字符串还原为对象
          storedData = JSON.parse(storedData);
        } catch (error) {
          // 如果解析失败，打印错误信息并返回 null
          console.error('Error parsing stored data: ', error);
          return null;
        }

        if (storedData.date === currentFormattedDate) {
          // 如果 localStorage 中的数据日期是当前日期，返回该数据
          return storedData.data;
        }
      }
      return null;
    };

    const getSalesCount = async () => {
      try {
        const response = await axios.get(
          `https://script.google.com/macros/s/AKfycby0bxfq2i_ZbdtoUsOMH80Djj7XwR1WZmZST6-WHYdtJPBJdQ4s53E6rV6uMO26NZRQ/exec`,
          {
            params: {
              op: 'getSalesCount',
            },
          }
        );
        const data = response.data;
        // 用 setState 更新本地状态
        setSalesData(data);
        // 将获取到的新数据存储到 localStorage
        if (typeof window !== 'undefined') {
          window.localStorage.setItem('salesData', JSON.stringify({ date: getFormattedDate(), data: data }));
        }
      } catch (error) {
        console.log(error);
      }
    };

    let sales = checkLocalStorageForData();
    if (sales) {
      setSalesData(sales);
    } else {
      getSalesCount();
    }
  }, []);

  const {
    site: {
      siteMetadata: { colorMap },
    },
  } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          colorMap {
            key
            value
          }
        }
      }
    }
  `);
  // const isMinimum = minVariantPrice.amount !== maxVariantPrice.amount;

  const price = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(parseFloat(variantPrice) > PRICE_THRESHOLD ? parseFloat(variantPrice) - DISCOUNT_AMOUNT : parseFloat(variantPrice));

  const zoomImgProps = {
    width: windowWidth < 450 ? windowWidth - 2 : 400,
    height: windowWidth < 450 ? windowWidth - 2 : 400,
    zoomWidth: 450,
    zoomPosition: 'left',
    offset: { vertical: 0, horizontal: 8 },
    img: getSrc(images[activeImage].image.gatsbyImageData),
  };

  const handleClick = (optionIndex: any, value: any, index: number) => {
    const currentOptions = [...variant.selectedOptions];
    currentOptions[optionIndex] = {
      ...currentOptions[optionIndex],
      value,
    };
    const selectedVariant = find(variants, ({ selectedOptions }) => isEqual(currentOptions, selectedOptions));
    // @ts-ignore
    setVariant({ ...selectedVariant });
    setActiveImage(index);
  };

  const handleQuantityChange = (value: number) => {
    setQuantity(value);
  };

  const addToCart = async () => {
    if (!variantAvailable) {
      return;
    }
    await addVariantToCart!(variant.shopifyId, quantity.toString());
    // add extra strap
    for (let index = 0; index < leatherStraps.length; index++) {
      const { shopifyId, title, availableForSale } = leatherStraps[index];
      if (availableForSale && extraStrap[index]) {
        await addVariantToCart!(shopifyId, '1');
      }
    }

    setOpen(true);
    // add mautic tracking
    trackMautic({
      eventName: 'add-to-cart/add-point/3',
      eventDescription: `${product.title.split(' ')[2]} - ${variant.title}`,
      tags: 'Interest', // 安全标签
      cart: `${product.title.split(' ')[2]} - ${variant.title}`,
    });
    // fire GTM add_to_cart event
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: 'USD',
        value:
          parseFloat(variant.price) > PRICE_THRESHOLD
            ? parseFloat(((parseFloat(variant.price) - DISCOUNT_AMOUNT) * quantity).toFixed(2))
            : parseFloat((parseFloat(variant.price) * quantity).toFixed(2)),
        items: [
          {
            item_id: `${product.title.split(' ')[2]} ${variant.title}`,
            item_name: product.title.split(' ')[2],
            item_brand: 'Pagani Design',
            item_category: 'Watches',
            item_variant: variant.title,
            price:
              parseFloat(variant.price) > PRICE_THRESHOLD
                ? parseFloat((parseFloat(variant.price) - DISCOUNT_AMOUNT).toFixed(2))
                : parseFloat(parseFloat(variant.price).toFixed(2)),
            currency: 'USD',
            index: activeImage + 1,
            quantity: quantity,
            language: language,
          },
        ],
      },
    });
  };
  const handleClose = () => {
    setOpen(false);
  };

  const getSales = (product) => {
    let model = product.title.split(' ')[2].toLowerCase();
    if (salesData) {
      if (model in salesData) {
        return salesData[model];
      }
    }
    return 0;
  };

  const siteUrl = 'https://www.paganidesignwatch.com';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', pad: 'row' },
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        mt: { xs: 1, sm: 2, md: 3, pad: 4, lg: 5 },
        mb: '2rem',
        minHeight: 'calc(100vh - (34px + 64px) + 10px)',
      }}>
      {/*Image list and active image*/}
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'flex-start', justifyContent: 'flex-start' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            width: { sm: 'calc(100vw - 40px)', md: `${activeWindowWidth}px`, pad: '300px', lg: '400px' },
            maxWidth: { sm: '580px', md: '400px' },
            order: { xs: 1, md: 0 },
            ml: { xs: '0px', md: '10px' },
            mb: { xs: '10px' },
          }}>
          {/*Image list*/}
          {windowWidth < 768 ? (
            <List
              className="thumbnail"
              sx={{
                width: '100%',
                maxWidth: { xs: 'calc(100vw - 32px)', sm: '490px' },
                maxHeight: '120px',
                p: 0,
                overflowX: 'hidden',
                overflowY: 'hidden',
              }}>
              <Slider
                {...ThumbnailSlickProps}
                customPaging={(i) => (
                  <div
                    style={{
                      position: 'absolute',
                      width: '100%',
                      bottom: '15px',
                      opacity: 0,
                    }}>
                    {i}
                  </div>
                )}>
                {thumbnails.map(({ id, image }, index) => {
                  const src = getSrc(image.gatsbyImageData);
                  const alt = src.split('/').pop().split('_')[0];
                  return (
                    <Thumbnail
                      key={index}
                      elevation={0}
                      variant="outlined"
                      sx={{
                        width: '100px',
                        height: '100px',
                        p: '1px',
                        borderRadius: '2px',
                      }}
                      active={activeImage === index}
                      onClick={() => setActiveImage(index)}>
                      <LazyLoader
                        priority={LazyLoader.Priority.LOW}
                        placeholder={
                          <div
                            style={{
                              height: '100px',
                              width: '100px',
                              backgroundColor: '#FFFFFF',
                              margin: '0 10px', // 保持轮播项间距
                            }}
                          />
                        }>
                        <img src={src} alt={alt} loading="eager" style={{ width: '100%', maxWidth: '100px', aspectRatio: '1/1' }} />
                      </LazyLoader>
                    </Thumbnail>
                  );
                })}
              </Slider>
            </List>
          ) : (
            <>
              {thumbnails.map(({ id, image }, index) => {
                const src = getSrc(image.gatsbyImageData);
                const alt = src.split('/').pop().split('_')[0];
                return (
                  <Thumbnail
                    key={index}
                    elevation={0}
                    variant="outlined"
                    sx={{
                      width: { xs: '80px', sm: '90px', md: '100px' },
                      height: { xs: '80px', sm: '90px', md: '100px' },
                      p: '1px',
                      borderRadius: '2px',
                    }}
                    active={activeImage === index}
                    onClick={() => setActiveImage(index)}>
                    <img src={src} alt={alt} loading="lazy" max-width="100%" height="100%" />
                  </Thumbnail>
                );
              })}
            </>
          )}
        </Box>
        {/*Active image*/}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            order: { xs: 0, md: 1 },
          }}>
          <LazyLoader
            priority={LazyLoader.Priority.LOW}
            placeholder={
              <div
                style={{
                  height: '400px',
                  width: '400px',
                  backgroundColor: '#FFFFFF',
                  margin: '0 10px', // 保持轮播项间距
                }}
              />
            }>
            <Paper
              elevation={0}
              sx={{
                // width: "400px",
                // height: "400px",
                ml: { xs: 0, sm: '10px' },
                mb: { xs: '10px' },
                width: windowWidth < 450 ? windowWidth - 2 : 400,
                height: windowWidth < 450 ? windowWidth - 2 : 400,
              }}>
              <ReactImageZoom {...zoomImgProps} />
            </Paper>
          </LazyLoader>
        </Box>
      </Box>

      {/*Details and price*/}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', ml: { xs: '10px' } }}>
        <Typography variant="body1" component="h1" id="title" sx={{ pr: 3 }}>
          <Trans>{product.title}</Trans>
        </Typography>
        <Stack direction="row" spacing={0.5} sx={{ py: '0.5rem' }}>
          <Typography variant="body2" component="h2">
            USD {price}
          </Typography>
          {getSales(product) > 0 ? (
            <Chip
              label={`${getSales(product)} Sold`}
              size="small"
              sx={{
                backgroundColor: '#ffebee',
                color: '#e57373',
                fontSize: '0.9rem',
              }}
            />
          ) : (
            <></>
          )}
        </Stack>
        {options.map(({ shopifyId, name, values }, optionIndex) => {
          if (name === 'Color') {
            return (
              <Box
                key={optionIndex}
                sx={{
                  display: 'flex',
                  flexGrow: 1,
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-start',
                  flexWrap: 'wrap',
                  pb: '0.3rem',
                }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexGrow: 1,
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                  }}>
                  <Typography variant="body2" component="h2" sx={{ pr: '0.5rem' }}>
                    <Trans>Select {name}:</Trans>
                  </Typography>
                  <Typography variant="body2" component="h2" color="primary">
                    {variant.selectedOptions[optionIndex].value.toUpperCase()}
                  </Typography>
                </Box>
                <Box
                  key={shopifyId}
                  sx={{
                    display: 'flex',
                    flexGrow: 1,
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    flexWrap: 'wrap',
                    py: '0.3rem',
                  }}>
                  {values.map((value, index) => {
                    if (!value.includes('https://amzn.to/'))
                      return (
                        <ActiveWrapper
                          elevation={0}
                          variant="outlined"
                          key={index}
                          active={variant.selectedOptions[optionIndex].value === value}
                          available={variants[index].availableForSale}
                          onClick={() => handleClick(optionIndex, value, index)}
                          title={value}
                          sx={{ mr: '2px', mb: '2px', p: 0, lineHeight: '0', borderWidth: '2px' }}>
                          <ProductColorValue src={getSrc(variants[index].image.gatsbyImageData)} alt={`${value}`} />
                        </ActiveWrapper>
                      );
                  })}
                </Box>
              </Box>
            );
          }
        })}
        {/*quantity set*/}
        <NumberInput min={1} max={150} fontsize="14px" value={quantity} onChange={handleQuantityChange} isLight={true} />

        {/*add extra leather straps*/}
        {!product.title.includes('PS-') && product.descriptionHtml.includes('Extra Strap:') && (
          <>
            <Typography variant="body1" component="h1">
              <Trans>Choose an Extra Item</Trans>
            </Typography>
            <List
              className="extra-strap"
              sx={{
                width: '100%',
                maxWidth: { xs: 'calc(100vw - 32px)', md: '630px', lg: '440px' },
                maxHeight: '340px',
                p: 0,
                overflowX: 'hidden',
                overflowY: 'hidden',
              }}>
              <Slider
                {...ExtraStrapSlickProps}
                customPaging={(i) => (
                  <div
                    style={{
                      position: 'absolute',
                      width: '100%',
                      bottom: '-15px',
                      opacity: 0,
                    }}>
                    {i}
                  </div>
                )}>
                {leatherStraps.map(({ name, title, availableForSale, price, image }, index) => {
                  const [checked, setChecked] = useState(false);
                  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
                    extraStrap.splice(index, 1, event.target.checked);
                    setExtraStrap(extraStrap);
                    setChecked(event.target.checked);
                  };
                  return (
                    availableForSale &&
                    product.descriptionHtml.includes(name) && (
                      <ListItem
                        key={index}
                        alignItems="flex-start"
                        sx={{ maxWidth: { xs: '120px', sm: '130px', md: '140px', pad: '130px' }, p: 0 }}>
                        <FormControl
                          sx={{
                            p: 0,
                            m: 0,
                            width: { xs: '120px', sm: '130px', md: '140px', pad: '130px' },
                            minWidth: 0,
                            overflow: 'hidden',
                            maxWidth: '130px',
                            display: 'flex',
                          }}>
                          <FormControlLabel
                            sx={{ alignItems: 'flex-start', p: 0, m: 0, width: { xs: '120px', sm: '130px', md: '140px', pad: '130px' } }}
                            control={
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  m: 0,
                                  p: 0,
                                  width: { xs: '120px', sm: '130px', md: '140px', pad: '130px' },
                                }}>
                                <Checkbox size="medium" sx={{ m: 0, p: 0 }} checked={checked} onChange={handleChange} />
                                <Typography variant="body2" component="h3">
                                  ${`${price}`}
                                </Typography>
                              </Box>
                            }
                            label={
                              <Box sx={{ width: { xs: '120px', sm: '130px', md: '140px', pad: '130px' } }}>
                                <LazyLoader
                                  priority={LazyLoader.Priority.LOW}
                                  placeholder={
                                    <div
                                      style={{
                                        height: '140px',
                                        width: '140px',
                                        backgroundColor: '#FFFFFF',
                                        margin: '0 10px', // 保持轮播项间距
                                      }}
                                    />
                                  }>
                                  <img src={`${image}`} alt="strap" style={{ width: '100%', maxWidth: '140px', aspectRatio: '1/1' }} />
                                </LazyLoader>
                                <FormHelperText variant="body1" component="h1">
                                  {`${name}`}
                                  {`   20mm`}
                                </FormHelperText>
                                <FormHelperText variant="body1" component="h1">
                                  {`${title}`}
                                </FormHelperText>
                              </Box>
                            }
                            labelPlacement="top"
                          />
                        </FormControl>
                      </ListItem>
                    )
                  );
                })}
              </Slider>
            </List>
          </>
        )}

        {/*Add to Cart Button*/}
        <Box onClick={addToCart} sx={{ cursor: 'pointer', my: '0.1rem' }}>
          <Button
            id="addToCart"
            className="addToCart"
            variant="contained"
            size="small"
            color="primary"
            endIcon={<AddShoppingCartIcon />}
            disabled={!variantAvailable}
            sx={{ width: '50%', minWidth: '230px', my: '0.3rem', zIndex: '-1', cursor: 'pointer' }}>
            {!variantAvailable ? <Trans>sold out</Trans> : <Trans>add to cart</Trans>}
          </Button>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={open} autoHideDuration={2000} onClose={handleClose}>
            <Alert onClose={handleClose} variant="filled" severity="success">
              Product added to your cart successully!
            </Alert>
          </Snackbar>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            height: '50px',
            my: '1.2rem',
          }}>
          <img loading="lazy" src={trustMoneyBack} height="48" alt="30 day money back guarantee" loading="lazy" />
          <img loading="lazy" src={trustReturns} height="48" alt="30 day returns" loading="lazy" />
          <img loading="lazy" src={trustWarranty} height="48" alt="12 month warranty" loading="lazy" />
          <img loading="lazy" src={trustCheckout} height="48" alt="100% safe and secure checkout" loading="lazy" />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            width: '100%',
            pt: '1.0rem',
            lineHeight: '1.2rem',
            color: '#00000099',
          }}>
          <Typography variant="caption" component="h3" sx={{ width: '100%' }}>
            <Trans>Reference Dilivery Time From China:</Trans>
          </Typography>
          <Typography variant="caption" component="h3" sx={{ width: { xs: '50%', sm: '33%', md: '50%', pad: '33%' } }}>
            <Trans>Asia: 2-7 Days</Trans>
          </Typography>
          <Typography variant="caption" component="h3" sx={{ width: { xs: '50%', sm: '33%', md: '50%', pad: '33%' } }}>
            <Trans>Europe: 3-14 Days</Trans>
          </Typography>
          <Typography variant="caption" component="h3" sx={{ width: { xs: '50%', sm: '33%', md: '50%', pad: '33%' } }}>
            <Trans>MiddleEast: 7-14 Days</Trans>
          </Typography>
          <Typography variant="caption" component="h3" sx={{ width: { xs: '50%', sm: '33%', md: '50%', pad: '33%' } }}>
            <Trans>North America: 5-14 Days</Trans>
          </Typography>
          <Typography variant="caption" component="h3" sx={{ width: { xs: '50%', sm: '33%', md: '50%', pad: '33%' } }}>
            <Trans>South America: 8-20 Days</Trans>
          </Typography>
          <Typography variant="caption" component="h3" sx={{ width: { xs: '50%', sm: '33%', md: '50%', pad: '33%' } }}>
            <Trans>Africa: 8-20 Days</Trans>
          </Typography>
          <Typography variant="caption" component="h3" sx={{ width: '100%' }}>
            <Trans>More details, please refer our Shipping page.</Trans>
            <a rel="nofollow" href="/shipping">
              <Trans>Shipping</Trans>
            </a>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ProductHeaderContent;
